var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section-last-added-posts"},[_c('div',{staticClass:"container"},[_c('ul',{staticClass:"last-added-posts"},[_c('TestDrivePost',{attrs:{"posts":_vm.posts}}),_vm._l((_vm.lastAddedPosts),function(post){return _c('LastAddedPost',{key:post.id,attrs:{"post":post}})})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }